"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Donut = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_1 = __importDefault(require("@emotion/styled"));
var base_1 = require("./base");
var Donut = function (_a) {
    var size = _a.size, color = _a.color, width = _a.width, _b = _a.top, top = _b === void 0 ? "" : _b, _c = _a.left, left = _c === void 0 ? "" : _c, _d = _a.right, right = _d === void 0 ? "" : _d, _e = _a.bottom, bottom = _e === void 0 ? "" : _e, _f = _a.className, className = _f === void 0 ? "anim-shape-donut" : _f, _g = _a.zIndex, zIndex = _g === void 0 ? "-1" : _g, _h = _a.breakpoints, breakpoints = _h === void 0 ? [600, 900, 1200] : _h, _j = _a.position, position = _j === void 0 ? "absolute" : _j;
    var StyledDonut = (0, styled_1["default"])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: inherit;\n    height: inherit;\n    width: inherit;\n    background-color: transparent;\n    border: ", ";\n    border-width: ", ";\n    border-style: solid;\n    border-radius: 50%;\n    top: inherit;\n    left: inherit;\n    right: inherit;\n    z-index: inherit;\n  "], ["\n    position: inherit;\n    height: inherit;\n    width: inherit;\n    background-color: transparent;\n    border: ", ";\n    border-width: ", ";\n    border-style: solid;\n    border-radius: 50%;\n    top: inherit;\n    left: inherit;\n    right: inherit;\n    z-index: inherit;\n  "])), color, width);
    return ((0, jsx_runtime_1.jsx)(base_1.BaseShape, __assign({ bottom: bottom, breakpoints: breakpoints, className: className, height: size, left: left, position: position, right: right, top: top, width: size, zIndex: zIndex }, { children: (0, jsx_runtime_1.jsx)(StyledDonut, { className: className }, void 0) }), void 0));
};
exports.Donut = Donut;
var templateObject_1;
